import { useSelector } from 'react-redux';

import { selectHasWatermarkAvailable } from '../slice/entityScopeSlice';

export const WATERMARK_STORAGE_KEY = 'hasWatermark';

/**
 * Single source of truth for "does the selected org have a watermark on file?"
 *
 * Only an explicit `false` counts as "no watermark on file". Unknown/absent is
 * treated as available so we never over-disable the watermark toggle — and so
 * is "no org selected", whatever the last one's flag was (DV-2849; see
 * `selectHasWatermarkAvailable`).
 *
 * DV-3013: this used to read localStorage once at mount, on the stated premise
 * that "the value only changes across a full org switch (which reloads the
 * page), so a one-time read at mount is sufficient". PR 3 removes that reload,
 * so the read is now a subscription to the scope slice (spec §2.1 class A).
 */
export function useOrgWatermarkAvailable(): boolean {
  return useSelector(selectHasWatermarkAvailable);
}
